import { render, staticRenderFns } from "./demand-zp.vue?vue&type=template&id=00f539c0&scoped=true"
import script from "./demand-zp.vue?vue&type=script&lang=js"
export * from "./demand-zp.vue?vue&type=script&lang=js"
import style0 from "./demand-zp.vue?vue&type=style&index=0&id=00f539c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f539c0",
  null
  
)

export default component.exports